import styled from '@emotion/styled';

const FormTitle = styled.h1`
  color: var(--fett-text-secondary);
`;

export const SubTitle = styled.div`
  color: var(--fett-text-secondary);
  padding-bottom: 24px;
`;

export default FormTitle;
